import React from 'react';
// import cookies from 'js-cookie';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import HtmlTemplateOne from './Template1/HtmlTemplate1';
import HtmlTemplateTwo from './Template2/HtmlTemplate2';
import HtmlTemplateThree from './Template3/HtmlTemplate3';
import HtmlTemplateFour from './Template4/HtmlTemplate4';
import HtmlTemplateFive from './Template5/HtmlTemplate5';
import HtmlTemplateSix from './Template6/HtmlTemplate6';
import HtmlTemplateSeven from './Template7/HtmlTemplate7';
import HtmlTemplateEight from './Template8/HtmlTemplate8';
import HtmlTemplateNine from './Template9/HtmlTemplate9';
import HtmlTemplateTen from './Template10/HtmlTemplate10';
import HtmlTemplateEleven from './Template11/HtmlTemplate11';
import HtmlTemplateTwelve from './Template12/HtmlTemplate12';
import HtmlTemplateThirteen from './Template13/HtmlTemplate13';
import HtmlTemplateFifteen from './Template15/HtmlTemplate15';
import HtmlTemplateEightteen from './Template18/HtmlTemplate18';
import HtmlTemplateNineteen from './Template19/HtmlTemplate19';
import HtmlTemplateTwenty from './Template20/HtmlTemplate20';
import HtmlTemplateTwentyOne from './Template21/HtmlTemplate21';
import HtmlTemplateTwentyTwo from './Template22/HtmlTemplete22';
import HtmlTemplateTwentyThree from './Templete23/HtmlTemplete23';
import HtmlTemplateTwentyFive from './Template25/HtmlTemplate25';
import HtmlTemplateTwentySix from './Templete26/HtmlTemplete26';
import HtmlTemplateTwentySeven from './Template27/HtmlTemplate27';
import HtmlTemplateTwentyEight from './Template28/HtmlTemplate28';
import HtmlTemplateTwentynine from './Template29/HtmlTemplate29';
import HtmlTemplateThirty from './Template30/HtmlTemplate30';
import HtmlTemplateThirtyOne from './Template31/HtmlTemplate31';
import HtmlTemplateThirtyThree from './Template33/HtmlTemplate33';
import HtmlTemplateThirtyFour from './Template34/HtmlTemplate34';

function HtmlRenderPage() {
  const templateData = useSelector((state) => state?.currentTemplate?.templateContent);
  const { id } = useParams();

  const pageObject = [
    HtmlTemplateOne, HtmlTemplateTwo, HtmlTemplateThree, HtmlTemplateFour,
    HtmlTemplateFive, HtmlTemplateSix, HtmlTemplateSeven, HtmlTemplateEight,
    HtmlTemplateNine, HtmlTemplateTen, HtmlTemplateEleven, HtmlTemplateTwelve,
    HtmlTemplateThirteen, '', HtmlTemplateFifteen, '', '', HtmlTemplateEightteen,
    HtmlTemplateNineteen, HtmlTemplateTwenty, HtmlTemplateTwentyOne, HtmlTemplateTwentyTwo,
    HtmlTemplateTwentyThree, '', HtmlTemplateTwentyFive, HtmlTemplateTwentySix, HtmlTemplateTwentySeven,
    HtmlTemplateTwentyEight, HtmlTemplateTwentynine, HtmlTemplateThirty, HtmlTemplateThirtyOne,
    '', HtmlTemplateThirtyThree, HtmlTemplateThirtyFour,
  ];

  const Page = pageObject[id - 1];
  return (
    <Page templateData={templateData} />
  );
}

export default HtmlRenderPage;
